import {defineNuxtPlugin} from "#app";
import {ref} from "vue";
import { useTheme } from "vuetify";
import { CometChat } from "@cometchat/chat-sdk-javascript";
import {CometChatUIKit} from "@cometchat/chat-uikit-vue";
import {CometChatTheme} from "@cometchat/uikit-resources";
import {UIKitSettingsBuilder} from "@cometchat/uikit-shared";
import {PaletteItem, CometChatFont} from "@cometchat/uikit-resources";
import vuetifyColors from "../vuetify.colors";

export default defineNuxtPlugin(async (nuxtApp) => {
    const config = useRuntimeConfig();

    var colors = vuetifyColors;
    //Get the vue theme
    var customTheme = new CometChatTheme({});
    customTheme.palette.primary = new PaletteItem({light : colors.primary, dark : colors.primary});
    customTheme.palette.secondary = new PaletteItem({light : colors.borderLight, dark : colors.borderLight});
    customTheme.palette.error = new PaletteItem({light : colors.error, dark : colors.error});
    customTheme.palette.accent = new PaletteItem({light : colors.accent, dark : colors.accent});
    customTheme.typography.fontFamily = "Poppins";
    customTheme.typography.name = new CometChatFont({fontFamily : "Poppins", fontWeight : "normal"});
    customTheme.typography.heading = new CometChatFont({fontFamily : "Poppins", fontWeight : "bold"});
    customTheme.typography.subtitle1 = new CometChatFont({fontFamily : "Poppins", fontWeight : "bold", fontSize : "12px"});
    customTheme.typography.subtitle2 = new CometChatFont({fontFamily : "Poppins", fontWeight : "normal", fontSize : "12px"});
    customTheme.typography.caption1 = new CometChatFont({fontFamily : "Poppins", fontWeight : "normal", fontSize : "12px"});
    customTheme.typography.caption2 = new CometChatFont({fontFamily : "Poppins", fontWeight : "normal", fontSize : "12px"});
    customTheme.typography.text1 = new CometChatFont({fontFamily : "Poppins", fontWeight : "normal", fontSize : "12px"});
    customTheme.typography.text2 = new CometChatFont({fontFamily : "Poppins", fontWeight : "bold", fontSize : "12px"});
    customTheme.typography.text3 = new CometChatFont({fontFamily : "Poppins", fontWeight : "normal", fontSize : "14px"}); // Message text
    customTheme.typography.title1 = new CometChatFont({fontFamily : "Poppins", fontWeight : "bold"});
    customTheme.typography.title2 = new CometChatFont({fontFamily : "Poppins", fontWeight : "bold"});

    const theme = ref<any>(customTheme);
    const isMobileView = ref(false);

    function switchView() {
        if (window.innerWidth >= 320 && window.innerWidth <= 760) {
            isMobileView.value = true;
        } else {
            isMobileView.value = false;
        }
    }

    function switchThemeMode() {
        if (theme.value.palette.mode === "dark") {
            theme.value.palette.setMode("light");
        } else {
            theme.value.palette.setMode("dark");
        }
    }

    // Initialize CometChatUIKit
    const UIKitSettings = new UIKitSettingsBuilder()
        .setAppId(config.public.cometChatAppId)
        .setRegion("eu")
        .setAutoEstablishSocketConnection(true)
        .subscribePresenceForAllUsers()
        .build();

    try {
        await CometChatUIKit.init(UIKitSettings);
        // Provide values globally in Vue app
        nuxtApp.vueApp.provide("theme", {theme, switchThemeMode});
        nuxtApp.vueApp.provide("isMobileView", {isMobileView, switchView});

        // Run initial check
        switchView();
        window.addEventListener("resize", switchView);
    } catch (err) {
        console.error("Error initializing CometChat:", err);
    }
    return {
        provide: {
            cometChatSdk: CometChat,
            cometChatUiKit: CometChatUIKit
        }
    }
});
